<template>
    <div>
        <div class="form-modal-container animate__animated animate__fadeInUp">
            <div class="form-modal">
                <div class="close-btn">
                    <button class="close" @click="closeModal">
                        <span aria-hidden="true">&times;</span></button>
                </div>
                <div class="row d-flex justify-content-center">
                    <div class="col-md-10 col-12">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </div>
        <div @click="closeModal" class="cover-bg animate__animated animate__fadeIn"></div>
    </div>
</template>

<script>
import fire from '../fire';

export default {
    name: 'Modal',
    props: {
        closeModal: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
        }
    }
}
</script>